import React from "react";
import Table from "@mui/joy/Table";
import useFormattedData from "./hooks/useFormattedData";
import { getValue } from "../Helpers";
import { Button, DialogContent, Input, Modal, ModalDialog } from "@mui/joy";
import { ApiService } from '../../api/ProjectInfoService';

interface TableProps {
  data: any[];
  columns: {
    id: number;
    label: string;
    property: string;
  }[];
  projectId?: string;
  deletable?: boolean;
  editable?: boolean;
  downloadNeeded?: boolean;
  onSave?: (data: any) => void;
  onClick?: (data: any) => void;
}

const DynamicTable = ({ data, columns, editable= false , onSave,downloadNeeded = false, projectId = ""}: TableProps) => {
  const formattedData = useFormattedData({ data, columns });

  // on tr click, open modal with details:
  const [open, setOpen] = React.useState<boolean>(false);
  const [rowData, setRowData] = React.useState<any>(null);
  const [editedStartDate, setEditedStartDate] = React.useState<string>("");
  const [editedEndDate, setEditedEndDate] = React.useState<string>("");
  const [contact, setContact] = React.useState<any>(null);

  const handleRowClick = (data: any) => { 
    if (!editable) return;
        console.trace(data)
        if(downloadNeeded){
          Download(projectId, data.id, data.fileName, data.mimeType)
        }
        else{
          setOpen(true);
          setContact(data.id);
          setEditedStartDate(data.startDate); // Stel de huidige startdatum in als standaardwaarde
          setEditedEndDate(data.endDate); // Stel de huidige einddatum in als standaardwaarde
          setRowData(data);
        }
  }

  const Download = async (dospId: string, fileId: string, filename: string, contentType: string) => {

    console.trace(fileId); 
    console.trace(dospId); 
    
    const file = await ApiService.downloadFile(dospId, fileId) as any; 

    console.trace(filename); 
    console.trace(file);
    console.trace(file.data) ;
    const Buffer = require('buffer').Buffer;
    const b64 = Buffer.from(file.data, 'binary').toString('base64');
    console.trace(b64); 
    const blob: Blob = b64toBlob(b64, contentType);

    const a = document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.setAttribute("download", filename);
    a.click();

    //const blob = new Blob([pdfBytes], { type: type,  });
    //const url = URL.createObjectURL(blob);
    //window.open(url);
  }

  const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  const handleSave = (data:any) => {
    if(editable) {
      const dataToSend = {
        ...rowData,
        contact: contact,
        startDate: editedStartDate,
        endDate: editedEndDate,
      }
      onSave!(dataToSend);
      setOpen(false);
    }
  }


  return (
    <div className="table">
      <Table hoverRow>
        <thead>
          <tr>
            {columns?.map((column) => ( (column.property !== "id" && column.property !== "fileContent") &&
              <th key={column?.id}>{column?.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {formattedData
            ?.filter(
              (data) =>
                (data.isActive && data.isActive === "Actief") || !data.isActive
            )
            .map((data) => (
              <tr key={data?.id} onClick={() => handleRowClick(data)} style={{cursor: "pointer"}}>
                {columns?.map((column) => ((column.property !== "id" && column.property !== "fileContent") &&
                  <td key={column?.id + " " + data?.id}>
                    {getValue(data, column)}
                  </td>
                ))}
              </tr>
              
            ))}
        <Modal className="modal" open={open} onClose={() => setOpen(false)}>
          <ModalDialog>
            <DialogContent>
              <h3>Bewerk Details</h3>
              <label>Start Datum</label>
              <Input
                type="date"
                value={editedStartDate}
                onChange={(event) => setEditedStartDate(event.target.value)}
              />
              <label>Eind Datum</label>
              <Input
                type="date"
                value={editedEndDate}
                onChange={(event) => setEditedEndDate(event.target.value)}
              />

              <Button onClick={handleSave}>Opslaan</Button>
            </DialogContent>
          </ModalDialog>
        </Modal>
        </tbody>
      </Table>
    </div>
  );
};

export default DynamicTable;
